<template>
  <j-abm name="zone" :suppliers="suppliers" :features="{
    search: false,
    create: true,
    update: true,
    delete: false,
  }" @create="onCreate" @update="onUpdate">
    <template #form="{ item }">

      <!-- General -->
      <div class="col-xl-5 col-lg-12 mb-2">
        <h5>{{ $t('general') }}</h5>
      </div>
      <div class="col-xl-7 col-lg-12">
        <a-form-model ref="general" :model="item" :rules="rules">
          <j-input prop="code" v-model="item.zone.code" icon="number" read-only />
          <j-enum-select prop="method" v-model="item.zone.method" @change="onMethodChange" />
          <j-field
           :label="$t('operators')"
            prop="zone.operators">
          <a-select
            v-model="item.zone.operators"
            mode="multiple"
            size="large">
              <a-select-option
               v-for="operator in operators"
               :key="operator.code"
               :value="operator.code">
               {{ $t(`enum.operator.${operator.code}`) }}
              </a-select-option>
            </a-select>
          </j-field>
          <j-field prop="zone.data.rate" :label="$t('rate')">
            <a-select v-model="item.zone.data.rate" size="large" @focus="fetchCodeRates()">
              <a-select-option v-for="codeRate in codesRates" :key="codeRate">
                {{ codeRate }}
              </a-select-option>
            </a-select>
          </j-field>

          <j-input prop="zone.eta.min" :label="$t('etaMin')" v-model="item.zone.eta.min" icon="down" />
          <j-input prop="zone.eta.max" :label="$t('etaMax')" v-model="item.zone.eta.max" icon="up" />
          <j-input prop="zone.data.route" :label="$t('route')" v-model="item.zone.data.route" icon="car" />
        </a-form-model>
      </div>

      <a-divider />

      <!-- Localitation -->
      <div class="col-xl-5 col-lg-12 mb-2">
        <h5>{{ $t('location') }}</h5>
      </div>
      <div class="col-xl-7 col-lg-12">
        <a-form-model ref="location" :model="item" :rules="rulesLocation">
          <!-- <j-input prop="timeZone" v-model="item.zone.data.time_zone" icon="clock-circle-o" :disabled="true" /> -->
          <j-input prop="country" v-model="item.zone.meta.country" icon="global" read-only />
          <j-field prop="zone.meta.state" :label="$t('state')">
            <a-select v-model="item.zone.meta.state" size="large" @focus="fetchStates()">
              <a-select-option v-for="state in states" :key="state">
                {{ state }}
              </a-select-option>
            </a-select>
          </j-field>
          <j-input prop="zone.meta.city" :label="$t('city')" v-model="item.zone.meta.city" icon="home" />
          <j-input prop="zone.data.region" :label="$t('region')" v-model="item.zone.data.region" icon="pushpin-o" />
          <j-input prop="zone.area" :label="$t('area')" v-model="item.zone.area" icon="tag-o" />
          <div class="mb-3">
            <label>{{ $t('zip') }}</label>
            <div class="d-flex mb-2">
              <a-input v-model="newZip" :placeholder="$t('addZip')" @keyup.enter="addZip(item)" size="large"
                :disabled="item.zone.method === 'EXPRESS' && item.zips.length >= 1">
                <a-icon slot="prefix" type="code-o" style="color: rgba(0,0,0,.25)" />
                <a-tooltip slot="suffix" :title="$t('addZip')">
                  <a-button icon="plus" shape="circle" size="small" class="plus-button" @click="addZip(item)" />
                </a-tooltip>
              </a-input>
            </div>
            <div v-if="zipError" class="text-danger" style="margin-top: 4px;">{{ zipError }}</div>
            <ul class="list-group">
              <li v-for="(code, idx) in item.zips" :key="code" class="list-group-item ant-input ant-input-lg">
                {{ code }}
                <a-button icon="minus" shape="circle" size="small" class="minus-button" @click="removeZip(item, idx)" />
              </li>
            </ul>
          </div>
        </a-form-model>
      </div>

    </template>
  </j-abm>
</template>

<script>
import lms from '@/api/lms'
import acl from '@/auth/acl'
import v from '@/utils/validators'
import f from '@/utils/formatters'
import JAbm from '@/views/shared/abm/update'
import JInput from '@/views/shared/forms/input'
import JEnumSelect from '@/views/shared/forms/enum-select'
import JField from '@/views/shared/forms/field'

export default {
  components: {
    JAbm,
    JInput,
    JEnumSelect,
    JField,
  },
  data: function () {
    return {
      f,
      acl,
      rules: {
        // method: [v.required],
        'zone.eta.min': [v.number, v.required],
        'zone.eta.max': [v.number, v.required],
        'zone.data.rate': [v.required, v.number],
        'zone.data.route': [v.required],
        'zone.operators': [
          {
            required: true,
            type: 'array',
            min: 1,
            message: this.$t('msg.validator.error.required'),
            trigger: 'change',
          }],
      },
      rulesLocation: {
        'zone.data.region': [v.required],
        'zone.meta.city': [v.required],
        'zone.meta.state': [v.required],
        'zone.area': [v.required],
      },
      newZip: '',
      states: [],
      regions: [],
      codesRates: [],
      zipError: '',
      operators: [],
    }
  },
  computed: {
    suppliers() {
      return {
        fetchOne: id => lms.zone.fetchOne(id).then(this.handleFetchOne),
        payload: () => {
          this.operators = [{ code: 'JPNK' }]
          return {
            zone: {
              code: '',
              data: {
                route: '',
                region: '',
                rate: 0,
                time_zone: 'EZE',
              },
              eta: {
                min: 0,
                max: 0,
              },
              meta: {
                city: '',
                state: '',
                country: 'AR',
              },
              method: 'EXPRESS',
              area: '',
              zips: [],
              operators: ['JPNK'],
            },
            zips: [],
          }
        },
      }
    },
  },
  methods: {
    handleFetchOne(res) {
      const method = res.data?.zone?.method || 'EXPRESS'
      this.updateAreaValidation(method)
      return this.setupForFetch(method, !res.data).then(() => res)
    },
    onCreate(zone) {
      this.onSubmit(zone, zone => lms.zone.create(zone))
    },
    onUpdate(zone) {
      this.onSubmit(zone, zone => lms.zone.update(zone))
    },
    onSubmit(zone, callback) {
      Promise.all([
        new Promise((resolve, reject) => this.$refs.general.validate(resolve)),
        new Promise((resolve, reject) => this.$refs.location.validate(resolve)),
        new Promise(resolve => this.validateZip(resolve)),
      ]).then(results => {
        if (results.every(Boolean)) {
          callback(zone).then(_ => this.$router.push('/zones'))
        }
      })
    },
    fetchStates() {
      lms.zone.fetchStates().then(states => {
        this.states = states.data
      })
    },
    fetchCodeRates() {
      lms.account.fetchCodeRates().then(rates => {
        this.codesRates = (rates.data || []).map(Number).filter(n => !Number.isNaN(n)).sort((a, b) => a - b)
      })
    },
    addZip(item) {
      if (!item.zips) item.zips = []
      const code = this.newZip.trim()
      if (!code || item.zips.includes(code)) return
      if (item.zone.method === 'EXPRESS' && item.zips.length >= 1) return
      item.zips.push(code)
      this.newZip = ''
      this.updateZipError(item.zips, item.zone.method)
    },

    removeZip(item, idx) {
      item.zips.splice(idx, 1)
      this.updateZipError(item.zips, item.zone.method)
    },

    updateZipError(zips, method) {
      const { message } = this.getZipValidation(zips, method)
      this.zipError = message
    },
    onMethodChange(newMethod) {
      this.updateAreaValidation(newMethod)
      const zips = this.$refs.location.model.zips
      this.updateZipError(zips, newMethod)
      this.setRoute(newMethod)
      this.handleOperator(newMethod)
    },
    getZipValidation(zips, method) {
      if (method === 'EXPRESS') {
        if (zips.length === 0) return { valid: false, message: this.$t('msg.zip.error.required') }
        if (zips.length > 1) return { valid: false, message: this.$t('msg.zip.error.onlyOne') }
      } else {
        if (zips.length === 0) return { valid: false, message: this.$t('msg.zip.error.required') }
      }
      return { valid: true, message: '' }
    },
    validateZip(resolve) {
      const zips = this.$refs.location.model.zips
      const method = this.$refs.location.model.zone.method
      const { valid, message } = this.getZipValidation(zips, method)
      this.zipError = message
      resolve(valid)
    },
    updateAreaValidation(method) {
      if (method === 'EXPRESS') {
        this.rulesLocation['zone.area'] = [v.required]
      } else {
        this.rulesLocation['zone.area'] = []
      }
    },
    setRoute(method) {
      const route = this.$refs.general.model.zone.data.route
      if (method !== 'EXPRESS' && (route === '' || route === null || route === undefined)) {
        this.$refs.general.model.zone.data.route = 'X'
      }
    },

    setupForFetch(method, isCreate) {
      return this.loadOperatorsByMethod(method).then(() => {
        if (isCreate) {
          this.setOperators()
        }
      })
    },

    loadOperatorsByMethod(method) {
      return lms.operator.fetchByMethod(method).then(res => {
        this.operators = res.data
      })
    },

    handleOperator(method) {
      this.loadOperatorsByMethod(method).then(() => {
        this.setOperators()
      })
    },

    setOperators() {
      if (this.$refs.general?.model?.zone) {
        this.$refs.general.model.zone.operators = this.operators.map(op => op.code)
      }
    },
  },
}
</script>

<style scoped>
.list-group-item {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.plus-button {
  color: #28a745;
  border-color: #28a745;
}

.minus-button {
  color: #dc3545;
  border-color: #dc3545;
}
</style>
